<template>
  <a-layout-header
    id="navbar"
    :class="{ [$style.navbar]: true, [$style.navbarFixed]: fixedNavbar }"
  >
    <div
      :class="$style.contentNavbar"
      class="navbar-content px-3 py-3"
    >
      <div class="navbar-row">
        <div class="navbar-menu text-center">
          <a-icon
            class="trigger"
            :type="isCollapsed ? 'menu-unfold' : 'menu-fold'"
            style="font-size: 20px"
            @click="onCollapse"
          />
        </div>

        <div class="navbar-business">
          <search-business />
        </div>

        <div class="navbar-actions d-flex justify-content-end align-items-center">
          <a-alert
            v-if="isSyncStock"
            class="navbar-alert"
            type="warning"
            style="font-size: 12px; padding: 5px 10px 4px 35px;"
            show-icon
            banner
          >
            <template slot="message">
              <span style="font-weight: bold">
                Sedang mensinkronisasi stok gudang <br />
                Mohon tidak me-refresh / menutup browser.
              </span>
              <span>
                <a-spin style="margin-top: -20px; margin-left: 5px">
                  <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                </a-spin>
              </span>
            </template>
          </a-alert>
          <a-alert
            v-if="isAddChannel"
            class="navbar-alert"
            type="warning"
            style="margin-left: 10px; font-size: 12px; padding: 5px 5px 4px 35px;"
            show-icon
            banner
          >
            <template slot="message">
              <span style="font-weight: bold">
                Sedang menyimpan {{ channelName }} <br />
                Mohon tidak me-refresh / menutup browser.
              </span>
              <span>
                <a-spin style="margin-top: -20px; margin-left: 5px">
                  <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                </a-spin>
              </span>
            </template>
          </a-alert>
          <a-dropdown>
            <a-menu slot="overlay" @click="changeLocale">
              <a-menu-item key="id-ID">
                <span role="img" aria-label="Indonesia">🇮🇩</span> Bahasa Indonesia
              </a-menu-item>
              <a-menu-item key="en-US">
                <span role="img" aria-label="English">🇺🇸</span> English
              </a-menu-item>
            </a-menu>
            <a-button class="navbar-locale" type="link" style="color: var(--color-black)">
              {{ locale === 'id-ID' ? 'ID' : 'EN' }} <a-icon type="down" />
            </a-button>
          </a-dropdown>
          <a-divider class="navbar-divider" type="vertical" />
          <div class="navbar-user">
            <User />
          </div>
        </div>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import dataNavbar from './composables/navbar'
import SearchBusiness from './Business'
import User from './User'

export default {
  name: 'NavbarV2',
  components: {
    SearchBusiness,
    User,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const { fixedNavbar } = dataNavbar(ctx)
    return { fixedNavbar }
  },
  data() {
    return {
      isCollapsed: this.collapsed,
    }
  },
  computed: {
    locale() {
      return this.$store.state.settings.locale
    },
    isSyncStock() {
      return this.$store.state.warehouse.syncing
    },
    isAddChannel() {
      return this.$store.state.marketplace.isAddChannel
    },
    channelName() {
      return this.$store.state.marketplace.channel
        ? this.$t('channel.product.' + this.$store.state.marketplace.channel)
        : ''
    },
  },
  watch: {
    collapsed(value) {
      this.isCollapsed = value
    },
  },
  methods: {
    onCollapse() {
      this.isCollapsed = !this.isCollapsed
      this.$emit('change', this.isCollapsed)
    },
    changeLocale({ key }) {
      this.$store.commit('settings/CHANGE_SETTING', { setting: 'locale', value: key })
    },
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>

<style lang="scss">
#navbar {
  .navbar-row {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    align-items: center;
    min-width: 0;
  }

  .navbar-menu {
    display: none;
    flex: 0 0 40px;
  }

  .navbar-business {
    flex: 1 1 250px;
    min-width: 0;
  }

  .navbar-actions {
    flex: 0 0 auto;
    gap: 4px;
    white-space: nowrap;
  }

  .navbar-divider {
    margin: 0 8px;
  }
}

@media (max-width: 800px) {
  #navbar {
    .navbar-content {
      padding: 8px 12px !important;
    }

    .navbar-row {
      display: grid !important;
      grid-template-columns: 32px minmax(0, 1fr) auto;
      gap: 8px;
      width: 100%;
    }

    .navbar-menu {
      display: block;
      flex-basis: 32px;
      grid-column: 1;
    }

    .navbar-business {
      min-width: 0;
      grid-column: 2;
    }

    .navbar-actions {
      grid-column: 3;
      min-width: 0;
    }

    .navbar-alert,
    .navbar-divider,
    .navbar-user .ant-btn > .anticon-down {
      display: none;
    }

    .navbar-locale,
    .navbar-user .ant-btn {
      padding-right: 4px;
      padding-left: 4px;
    }
  }
}
</style>
